import { useTranslation } from "react-i18next";
import Api from "../../../../constants/Api";
import MenuConfig from "../../../../constants/MenuConfig";
import ListPage from "../../../layouts/page/ListPage";
import { PerformancePlanEmployeeColumns } from "./Columns";

const PerformancePlanEmployeeList = () => {

    const { t } = useTranslation();

    return (
        <ListPage
            showPageTitle="true"
            activeMenu={t('performance.employee_plans')}
            motherMenu={t('performance.label')}
            path={Api.performance.employee_plan}
            route={MenuConfig.performance.employee_plan.route}
            columns={PerformancePlanEmployeeColumns}
            rowSelection="multiple"
        />
    );
}

export default PerformancePlanEmployeeList;
